import { defineComponent as _defineComponent } from 'vue'
import { computed, nextTick, ref } from 'vue'

import CareerAiJobCard from '@/components/CareerAIJobCard'
import { formatChatDate, renderMarkdown } from '@/utils/ai/careerAiText'

/* eslint-disable @typescript-eslint/no-explicit-any */

export default /*#__PURE__*/_defineComponent({
  __name: 'CareerAiMessageList',
  props: {
  messages: { type: Array as () => any[], default: () => [] },
  // 求人カードの実体。メッセージは jobIds しか持たない
  jobsCache: { type: Object, default: () => ({}) },
  loading: { type: Boolean, default: false },
  loadingText: { type: String, default: '考え中…' },
  quickReplies: { type: Array as () => string[], default: () => [] },
  showQuickReplies: { type: Boolean, default: false },
  // 「解決しましたか？」を出す対象index。出さないなら -1
  feedbackTargetIndex: { type: Number, default: -1 },
  feedbackGiven: { type: Object, default: () => ({}) },
  // 選択済みで移動待ちのAI機能。あるとき確認チップを出す
  pendingService: { type: Object, default: null },
  // 確認チップの文言。正本は utils/ai/careerChatMenu.json
  confirmLabels: { type: Object, default: () => ({ accept: '', cancel: '' }) },
  // 本日の上限に達していると送信できないため「この画面で続ける」を出さない
  canStayInChat: { type: Boolean, default: true }
},
  emits: [
  'apply',
  'prefill',
  'feedback',
  'contact-click',
  'link-click',
  'service-confirm',
  'service-stay',
  'service-cancel'
],
  setup(__props, { expose }) {

const props = __props;




const container = ref<HTMLElement | null>(null)

// 日付はマウント時点で確定。毎描画で new Date() を作らない
const chatDate = computed(() => formatChatDate(new Date()))

const getJob = (id: string): any => (props.jobsCache as any)[id] || null

const scrollToBottom = (): void => {
  nextTick(() => {
    const el = container.value
    if (el) el.scrollTop = el.scrollHeight
  })
}

expose({ scrollToBottom })

return { __sfc: true,props, container, chatDate, getJob, scrollToBottom, CareerAiJobCard, renderMarkdown }
}

})